<div >
    <mat-tab-group [selectedIndex]="tabIndex" (selectedTabChange)="onTabChanged($event)">
        <mat-tab label="{{'Document'|i18n}}" >
            <app-ocr-plus-txt #ocrPlusTxt [jsonData]="jsonData" [ocrPlus]="this" [class.rtlDir]="isRTL()"></app-ocr-plus-txt>
        </mat-tab>

     
        <mat-tab label="{{'Chat with AI'|i18n}}">
            <div>
                <app-chat-gpt-container #gptRf [ocrPlus]="this"></app-chat-gpt-container>
            </div>
        </mat-tab>        

    </mat-tab-group>
</div>